import { toast } from 'react-toastify';
import React from 'react';

import { wsTypes, wsOperations } from '../../reducers/websockets';
import { messageActions } from '../../reducers/messages';
import messageTypes from '../../reducers/messages/types';
import NewMessageNotification from '../../components/modules/newMessageToast';

export const messengerEvents = store => next => (action) => {
  if (action.type === wsTypes.SUBSCRIBE_TO_CHANNEL) {
    const { channelId } = action.payload;
    // listen all events
    wsOperations.listenEvent({
      topic: channelId,
      event: 'newMessage',
      action: messageActions.addMessage,
    })(store.dispatch);
    wsOperations.listenEvent({
      topic: channelId,
      event: 'updateMessage',
      action: messageActions.editMessage,
    })(store.dispatch);
    wsOperations.listenEvent({
      topic: channelId,
      event: 'deleteMessage',
      action: messageActions.removeMessage,
    })(store.dispatch);
    wsOperations.listenEvent({
      topic: channelId,
      event: 'userOnlineStatus',
      action: messageActions.changeUserOnlineStatus,
    })(store.dispatch);
  }
  if (action.type === messageTypes.ADD_MESSAGE) {
    const newMsgIn = action.payload.message.channel_id;

    const state = store.getState();

    if (state && state.messenger) {
      const { channel, unread_count, user } = action.payload;
      const { activeChat } = state.messenger;

      const isCurrentChatOpen = activeChat !== undefined && activeChat === newMsgIn;
      if (!isCurrentChatOpen) {
        const attributes = { ...channel, unread_count };
        store.dispatch(messageActions.changeChatAttr({ attributes, channel_id: newMsgIn }));
        toast(<NewMessageNotification channel_id={newMsgIn} user={user} />, { toastId: 'new-message' });
      }
    }

    store.dispatch(messageActions.setChannelsSorted({ channelIds: [newMsgIn], direction: 0 }));
  }
  next(action);
};



// WEBPACK FOOTER //
// ./src/utils/webSocketsMiddleware/events.js